import React from 'react';
import Dispatcher from '../../../../dispatcher/Dispatcher';
import { ActionType, Position } from '../../../../dispatcher/Types';
import { Component } from '../../../../index';
import { NOTIFICATION } from '../Types';
import { NOTIFICATION_DETAILS_PROPS, NOTIFICATION_DETAIL_DATA } from './Types';

class NotificationDetails extends Component<NOTIFICATION_DETAILS_PROPS> {
    renderDataItem = (dataItem: NOTIFICATION_DETAIL_DATA, notification: NOTIFICATION) => {
      const notifColon = ':';
      if (dataItem.type === 'action') {
        const { action, label: { locale, params, moduleName } } = dataItem;
        return (
          <tr key={action.name}>
            <td colSpan={2}>
              <a
                className="tp-toast-notification-details-action"
                onClick={() => {
                  Dispatcher.dispatch(action.name, action.type, action.data);
                  Dispatcher.dispatch('executeNotificationRemoval', { 
                    pos: Position.end
                  }, {
                    notification
                  });
                }}
              >
                {this.translate(locale, params, moduleName)}
              </a>
            </td>
          </tr>
        );
      } else if (dataItem.type === 'labelValue') {
        const { label: { locale, params, moduleName }, value } = dataItem;
        return (
          <tr key={locale}>
            <td className={'tp-font-size'}>
              <span>{this.translate(locale, params, moduleName) + notifColon}</span>
            </td>
            <td className={'tp-font-size tp-text-medium'}>
              <span>{value}</span>
            </td>
          </tr>
        );
      } else {
        const { label: { locale, params, moduleName } } = dataItem;
        return (
          <tr key={locale}>
            <td className={'tp-font-size'} colSpan={2}>
              <span>{this.translate(locale, params, moduleName)}</span>
            </td>
          </tr>
        );
      }
    };

    renderBody() {
      const { notification } = this.props;
      const { data } = notification.details;
      return (
        <div className="tp-toast-notification-details">
          <table>
            <tbody>
              {data.map(dataItem => this.renderDataItem(dataItem, notification))}
            </tbody>
          </table>
        </div>
      );
    }
}

export default NotificationDetails;
